import { render, staticRenderFns } from "./MerchantsUpdate.vue?vue&type=template&id=713e0498"
import script from "./MerchantsUpdate.vue?vue&type=script&lang=js"
export * from "./MerchantsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports